/**
 * @generated SignedSource<<665ad97350f7dcf74caabc36537ec27c>>
 * @relayHash 8d38d0982a264f657555f230c3f9149c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/514.0.0-2025-06-05T08:08:46.929Z/vipCuratedFolderRule_Query

import { ConcreteRequest } from 'relay-runtime';
export type vipCuratedFolderRule_Query$variables = {
  userId: string;
};
export type vipCuratedFolderRule_Query$data = {
  readonly viewer: {
    readonly isDisabled: boolean | null;
    readonly user: {
      readonly activityFeed: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly status: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  };
};
export type vipCuratedFolderRule_Query = {
  response: vipCuratedFolderRule_Query$data;
  variables: vipCuratedFolderRule_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": "isDisabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableCuratedFolders"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"disableCuratedFolders\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "elementTypes",
    "value": [
      "VIP_CURATED_PORTFOLIO_SHARE"
    ]
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "vipCuratedFolderRule_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "ActivityFeedConnection",
                "kind": "LinkedField",
                "name": "activityFeed",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActivityFeedEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActivityFeedElement",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "activityFeed(elementTypes:[\"VIP_CURATED_PORTFOLIO_SHARE\"],first:1)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "vipCuratedFolderRule_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "ActivityFeedConnection",
                "kind": "LinkedField",
                "name": "activityFeed",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActivityFeedEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActivityFeedElement",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "activityFeed(elementTypes:[\"VIP_CURATED_PORTFOLIO_SHARE\"],first:1)"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/514.0.0-2025-06-05T08:08:46.929Z/vipCuratedFolderRule_Query",
    "metadata": {},
    "name": "vipCuratedFolderRule_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e669af27fa7965cd38896f52f2d1d7c";

export default node;
